import { TableColumn } from "./dataInterface";

export const accountTableColumn: TableColumn = {
  title: "アカウント一覧",
  detail: true,
  detailTitle: "アカウント詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "アカウント登録",
  editAuth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
  tableFunction: [
    {
      name: "パスワードリセット",
      width: "130px",
      auth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "mail_address",
      name: "ログインID / メールアドレス",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: true,
      tableMinWidth: "220px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editId: "id",
      add: false,
      editType: null,
      addType: null,
      addMessage: "",
    },
    {
      key: "mail_address",
      name: "メールアドレス",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "text",
      addMessage: "半角数字（例:sample@sample.com）",
    },
    {
      key: "account_name",
      name: "氏名",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: true,
      editId: "id",
      editType: "text",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "authority",
      name: "権限",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: true,
      tableMinWidth: "130px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: true,
      editId: "id",
      editType: "list",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "login_status",
      name: "ログイン設定",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: false,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: true,
      editId: "id",
      editType: "list",
      add: true,
      addType: "list",
      addMessage:
        "※一度「ログイン不可能」として登録したアカウントを「正常」に変更することはできません",
    },
    {
      key: "sale_company_name",
      name: "パートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_company_id",
      name: "パートナー",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "company",
      addMessage: "",
    },
    {
      key: "sale_company_group_id",
      name: "グループ",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "group",
      detail: true,
      edit: true,
      editId: "id",
      editType: "list",
      add: true,
      addType: "group",
      addMessage: "",
    },
    {
      key: "sale_company_group_name",
      name: "グループ",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "group",
      detail: false,
      edit: false,
      editId: "id",
      editType: "list",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "phone_number",
      name: "TEL",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "kanzen",
      detail: true,
      edit: true,
      editId: "id",
      editType: "text",
      add: true,
      addType: "text",
      addMessage: "半角数字（例:12-3456-7890）",
    },
    {
      key: "outside_entry_site_key",
      name: "外部エントリーサイトキー",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: false,
      tableMinWidth: "320px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: "text",
      addMessage: "",
    },
    /*
    {
      key: "contract_number_year",
      name: "契約件数（一年）",
      table: true,tableMinWidth:'300px',
      sort: false,
      tableValue:'text',
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "contract_number_months",
      name: "契約件数",
      table: true,tableMinWidth:'300px',
      sort: false,
      tableValue:'text',
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "contract_price_year",
      name: "売上（一年）",
      table: true,tableMinWidth:'300px',
      sort: false,
      tableValue:'text',
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    */
    {
      key: "last_login_date",
      name: "最終ログイン",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "閲覧可能商材一覧",
      subTableColumnLength: "product_length",
      subTableColumnNameWidth: "115px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "閲覧可能商材詳細",
      subTableAdd: true,
      subTableAddTitle: "閲覧可能商材追加",
      subTableAddTitleWidth: "115px",
      subTableEdit: false,
      subTableEditTitle: "閲覧可能商材編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_name",
          name: "閲覧可能 商材名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "mgr_product",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "閲覧可能グループ一覧",
      subTableColumnLength: "group_length",
      subTableColumnNameWidth: "145px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "閲覧可能グループ詳細",
      subTableAdd: true,
      subTableAddTitle: "閲覧可能グループ追加",
      subTableAddTitleWidth: "145px",
      subTableEdit: false,
      subTableEditTitle: "閲覧可能グループ編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      tableFunction: [],
      subDataColumn: [
        {
          key: "group_name",
          name: "閲覧可能 グループ名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "mgr_group",
          addMessage: "",
        },
      ],
      subTable: [],
    },
  ],
};
